"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var map_types_1 = require("./map.types");
var installation_pin_container_component_1 = __importDefault(require("./installation-pin-container.component"));
var map_installation_details_component_1 = __importDefault(require("./map-installation-details.component"));
exports.getInstallationStatus = function (numberOfAlerts, numberOfWarnings, isOffline) {
    if (numberOfAlerts === void 0) { numberOfAlerts = 0; }
    if (numberOfWarnings === void 0) { numberOfWarnings = 0; }
    if (isOffline === void 0) { isOffline = false; }
    if (isOffline)
        return map_types_1.InstallationStatus.OFFLINE;
    if (numberOfAlerts)
        return map_types_1.InstallationStatus.ERROR;
    if (numberOfWarnings)
        return map_types_1.InstallationStatus.WARNING;
    return map_types_1.InstallationStatus.ALL_GOOD;
};
var MapInstallationPin = function (_a) {
    var installation = _a.installation, showDetails = _a.showDetails;
    var location = installation.location, url = installation.url, isActive = installation.isActive, numberOfWarnings = installation.numberOfWarnings, numberOfAlerts = installation.numberOfAlerts, isOffline = installation.isOffline;
    var _b = react_1.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var status = exports.getInstallationStatus(numberOfAlerts, numberOfWarnings, isOffline);
    return (react_1.default.createElement(installation_pin_container_component_1.default, { onMouseEnter: function () { return setIsFocused(true); }, onMouseLeave: function () { return setIsFocused(false); }, type: map_types_1.MapInstallationType.INSTALLATION, location: location, installationStatus: status, url: url, numberOfAlerts: numberOfAlerts, numberOfWarnings: numberOfWarnings, isActive: isActive }, isFocused && react_1.default.createElement(map_installation_details_component_1.default, { installation: installation, showDetails: showDetails })));
};
MapInstallationPin.displayName = 'MapInstallationPin';
exports.default = MapInstallationPin;
